<template>
	<v-container class="mt-12 pt-8" style="background: #fafafa;">
		<v-row style="background: #fafafa;">
			<v-col cols="12" class="mx-auto" PANNELS>
				<v-card :loading="loading">
					<v-card-title :class="`${arabic ? 'arFont' : 'enFont'}`">
						{{ i18n["language_level_update"] }}
					</v-card-title>
					<Paging 
						:resourceSettings="resourceSettings" 
						:resource="resource" 
						@loadResource="loadResource"
						@pageByNumber="pageByNumber" />
					<v-card-text>
						<v-row>
							<v-col cols="12" :class="`${arabic ? 'arFont' : 'enFont'}`" class="mb-2 py-0">
								<candidateLanguageLevelUpdate />
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { format } from 'timeago.js';
import Paging from '@/components/Paging'
import candidateLanguageLevelUpdate from '@/components/candidateLanguageLevelUpdate.vue';

export default {
	components: {
    Paging,
    candidateLanguageLevelUpdate
},
	data() {
		return {
			loading: false,
			resourceSettings: {
				resourceName: null,
				search: false,
				create: false,
				pagination: true,
			},
			resource: []
		}
	},
	computed: {
		user() {
			return this.$store.state.user
		},
		language() {
			return this.$store.state.language
		},
		i18n() {
			return this.$store.state.i18n[this.$store.state.language]
		},
		arabic() {
			if (this.$store.state.language == 'ar') return true
		},
	},
	methods: {
		formatDateToCurrentLocale(date) {
			let new_date = (new Date(date))
			return [
				new_date.toLocaleDateString(this.arabic ? 'ar' : 'en', {
					day: 'numeric',
					year: 'numeric',
					month: 'short',
				}),
				new_date.toLocaleTimeString(this.arabic ? 'ar' : 'en'),
			]
		},
		firstLettersName(name) {
			const split_names = name.split(" ")

			if (split_names.length > 1) return (split_names[0][0] + split_names[1][0]).toUpperCase()
			
			return (split_names[0][0] + split_names[0][1]).toUpperCase()
		},
		async pageByNumber(n) {
			return new Promise(async (res, rej) => {
					this.loading = true
					if (!this.search) {
							this.resource = await this.$store.dispatch('getResource', { resource: '/language-updates', page: `?page=${n}` })
					} else {
							this.resource = await this.$store.dispatch('searchResource', { resource: '/language-updates' + `/search?page=${n}`, value: this.search })
					}
					this.loading = false
			})
		},
		getFormat(d){
			return format(d)
		},
		async loadResource() {
				return new Promise(async (res, rej) => {
		this.resource = await this.$store.dispatch('getResource', { resource: '/language-updates' })
						res()
				})
		},
		async init() {
				this.loading = true
				await this.loadResource()
				this.loading = false
		},
	},
	async created() {
			await this.init()
	},
}
</script>